import axios from 'axios';
import {
    SecurityTypes
} from 'actions/types';

export function setCodeChallenge(code) {
    return {
        type: SecurityTypes.SET_CODE_CHALLENGE,
        payload: {
            codeChallenge: code
        }
    }
}

export function fetchVerifyToken() {
    return (dispatch, getState) => {
        try {
            var domains = getState().urls.get('domains');
            var headers = getState().config.get('headers').toJSON();
            var currentDomainIndex = getState().config.get('currentDomainIndex');
            var route = getState().urls.get('verify');
            var operatorId = getState().config.get('operatorId');
            var token = getState().security.get('accessToken');
            var codeChallenge = getState().security.get('codeChallenge');
            var method = route.get('method');
            var params = {
                token: token,
                appId: operatorId,
                code_challenge: codeChallenge,
            }
            var url = `${domains.get(currentDomainIndex)}${route.get('href')}`;
        } catch (error) {
            dispatch(tokenRejected(error))
            throw error;
        }

        dispatch({
            type: SecurityTypes.FETCH_VERIFY_TOKEN,
            payload: {
                method: method,
                url: url,
                params: params
            }
        })

        return axios({ method, url, headers, data: params })
        .then( ({ data }) => {
            dispatch({
                type: SecurityTypes.TOKEN_VERIFIED,
                payload: data
            });
            return data;
        })
        .catch( error => {
            const { status, data } = error.response || {};
            const normalized = {
                code: data?.code || status || error.code || 'UNKNOWN_ERROR',
                message: data?.message || error.message
            }
            dispatch(tokenRejected(normalized));
            throw normalized
        })
    }
}

export function tokenRejected(error) {
    return {
        type: SecurityTypes.TOKEN_REJECTED,
        payload: error
    }
}